<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Type <span class="text-danger">*</span></label>
          <select class="form-control" formControlName="type">
            <option *ngFor="let t of types" [value]="t.value">{{ t.label }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Périodicité <span class="text-danger">*</span></label>
          <select class="form-control" formControlName="periodicite">
            <option *ngFor="let p of periodicites" [value]="p.value">{{ p.label }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Mode de calcul <span class="text-danger">*</span></label>
          <select class="form-control" formControlName="modeCalcul">
            <option *ngFor="let m of modesCalcul" [value]="m.value">{{ m.label }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Montant <span class="text-danger">*</span></label>
          <input type="number" class="form-control" formControlName="montant">
        </div>
      </div>
      <div class="col-md-6" *ngIf="form.get('modeCalcul').value === 'POURCENTAGE'">
        <div class="form-group">
          <label>Taux (%)</label>
          <input type="number" class="form-control" formControlName="taux" step="0.01">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>État</label>
          <select class="form-control" formControlName="etat">
            <option *ngFor="let e of etats" [value]="e.value">{{ e.label }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Libellé</label>
          <input type="text" class="form-control" formControlName="libelle" placeholder="Libellé">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Date début</label>
          <input type="date" class="form-control" formControlName="dateDebut">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Date fin</label>
          <input type="date" class="form-control" formControlName="dateFin">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Montant payé</label>
          <input type="number" class="form-control" formControlName="montantPaye">
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Description</label>
          <textarea class="form-control" formControlName="description" rows="2"></textarea>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onClose()">Fermer</button>
  <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="onSubmit()">Enregistrer</button>
</div>
